$('.items').hover(function() {
  console.log('aaa');
  $('.items').attr('class','items ');
  var name = $(this).attr('data-name');
  $(this).parents('.card__content').find('.card__heading a').html(name);
  var price = $(this).attr('data-price');
  $(this).parents('.card__content').find('.price-item').html(price);
  var url = $(this).attr('data-url');
  $(this).parents('.card__content').find('.card__heading a').attr('href',url);
  var img = $(this).attr('data-image');
  $(this).parents('.card').find('.card__inner .media img').attr('srcset',img);
  $(this).parents('.card').find('.card__inner .card__content a').attr('href',url);
  $(this).attr('class','items active');
  if($(this).attr('data-available').length) {
    $(this).parents('.card-product2').find('.card__badge').removeClass('hidden');
  }else{
    $(this).parents('.card-product2').find('.card__badge').addClass('hidden');
  }
});

$('.items').click(function() {
  // $('.items').removeClass('active');
  // $(this).addClass('active');
});

